'use client'

import useSaveSearch from '@hooks/useSaveSearch'
import { cn } from '@utils'
import { useMemo } from 'react'
import { slugToQuery } from '../../utils'
import { get, pick } from 'lodash-es'

export default function SaveSearch({
  className = '',
  state,
  suburbs
}) {

  const { showSaveSearch } = useSaveSearch()
  const saveData = useMemo(() => {
    const routeParams = slugToQuery(state).toString()
    return {
      ...pick(routeParams, [
        'bedrooms',
        'bathrooms',
        'carspaces',
        'surrounding',
        'typeId',
        'isLandHome',
        'isProject',
        'categoryId',
        'landArea',
        'floorArea',
        'price',
        'order',
        'suburbId',
        'regionId',
        'districtId',
        'livingOptions'
      ]),
      listTime: Math.floor(Date.now() / 1000),
      filter: get(state, 'searchParams.filter')
    }
  }, [state])

  return (
    <button
      type='button'
      className={cn('button-primary-out h-auto xl:px-20 text-base whitespace-nowrap', className)}
      onClick={showSaveSearch({ data: saveData, suburbs, state })}
    >
      <i className='icon icon-heart !text-xl'></i>
      <span className='ml-6 hidden lg:block'>Save Search</span>
    </button>
  )
}